import { Flex, Form } from "antd"
import PropTypes from "prop-types"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"

const LabeledField = ({ labelKey, name, rules, validateTrigger, children }) => {
  const { t } = useTranslation()
  return (
    <Flex gap={spacings.XXS} vertical>
      <Text fw={500}>{t(labelKey)}</Text>
      <Form.Item name={name} rules={rules} validateTrigger={validateTrigger}>
        {children}
      </Form.Item>
    </Flex>
  )
}

LabeledField.propTypes = {
  labelKey: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.arrayOf(PropTypes.object),
  validateTrigger: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node
}

export default LabeledField
